/** @jsxImportSource react */
import { Button, Divider, Stack, Typography } from '@mui/material'
import GoogleIcon from '@mui/icons-material/Google'
import MicrosoftIcon from '@mui/icons-material/Microsoft'
import KeyIcon from '@mui/icons-material/VpnKeyOutlined'
import { useQuery } from '@tanstack/react-query'
import { authAPI } from '../../api/auth'

const ICONS = { google: GoogleIcon, microsoft: MicrosoftIcon }

/** Why a provider sign-in came back to the sign-in page (?sso_error=…). */
export const SSO_ERRORS = {
  cancelled: 'Sign-in was cancelled.',
  expired: 'That sign-in took too long or was opened in another browser. Please try again.',
  unverified_email: 'Your account there doesn’t have a verified email address, so it can’t be used here. Sign in with your password instead, or ask your administrator.',
  no_email: 'That account didn’t share an email address, so it can’t be used here.',
  inactive: 'This account has been switched off. Ask your administrator.',
  bad_token: 'The sign-in couldn’t be verified. Please try again.',
  unknown_provider: 'That sign-in option isn’t set up here.',
  provider: 'The sign-in service couldn’t be reached. Please try again in a moment.',
}

/** "Continue with Google / Microsoft / …" for the providers this installation has set up (none = nothing shown). */
const SsoButtons = ({ next, dividerLabel = 'or' }) => {
  const { data: providers = [] } = useQuery({ queryKey: ['sso', 'providers'], queryFn: authAPI.ssoProviders, staleTime: 10 * 60_000, retry: false })
  if (!providers.length) return null
  return (
    <>
      <Divider sx={{ my: 2 }}><Typography variant="caption" color="text.secondary">{dividerLabel}</Typography></Divider>
      <Stack spacing={1}>
        {providers.map((p) => {
          const Icon = ICONS[p.id] || KeyIcon
          return (
            // a full page load: the provider's sign-in page isn't an API call
            <Button key={p.id} variant="outlined" color="inherit" startIcon={<Icon />} href={authAPI.ssoStartUrl(p.id, next)}
              onClick={() => { try { localStorage.setItem('signedInWith', p.id) } catch { /* offers that calendar first later; optional */ } }}>
              Continue with {p.name}
            </Button>
          )
        })}
      </Stack>
    </>
  )
}

export default SsoButtons
